import { AsyncPipe, NgClass, NgFor, NgIf, NgOptimizedImage, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Observable, tap } from 'rxjs';

import { ModalComponent } from '../../shared/components/modal/modal.component';
import { StatusMessage } from '../../shared/interfaces/message-status.interface';
import { StatusMessageService } from '../../shared/services/status-message.service';
import { Layout } from '../../api/v1/models/layout';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { BreakpointService } from '../../shared/services/breakpoint.service';

@Component({
  selector: 'app-status-message',
  standalone: true,
  imports: [
    AsyncPipe,
    MatButtonModule,
    NgIf,
    NgFor,
    NgClass,
    NgOptimizedImage,
    NgSwitch,
    NgSwitchCase,
    ModalComponent
  ],
  templateUrl: './status-message.component.html',
  styleUrls: ['./status-message.component.scss']
})
export class StatusMessageComponent {
  constructor(
    private config: ConfigRepository,
    private statusMessage: StatusMessageService,
    private breakPoint: BreakpointService,
  ) {}

  layout$: Observable<Layout> = this.config.layout$;

  layouts = Layout;

  isShowStatusMessage: boolean = false;

  isMessageArray: boolean = false;

  statusMessage$: Observable<StatusMessage> = this.statusMessage.statusMessage$.pipe(
    tap((statusMessage) => {
      this.isMessageArray = Array.isArray(statusMessage.message);
      this.isShowStatusMessage = true;
    })
  );

  onClose(): void {
    if (this.breakPoint.isMobile) {
      setTimeout(() => {
        this.isShowStatusMessage = false;
      }, 300);
    } else {
      this.isShowStatusMessage = false;
    }
  }
}
